// extracted by extract-css-chunks-webpack-plugin
module.exports = {"itemCard":"_1q7FUb","last":"_30qAjQ","featuredItemsGrid":"YLuYvZ"};